module.exports = __webpack_public_path__ + "static/img/325.d2c39ad6.jpg";